import { axiosInstance } from "./api_instance";

export default async function sendCode(data) {
    try {
        const response = await axiosInstance.post("/submit", { ...data })
        return response
    } catch (error) {
        return error
    }
} 
